module.exports = __webpack_public_path__ + "img/poc_photo_default.deb7758e.png";